import * as React from 'react';
import { FC } from 'react';
import Box from '@mui/material/Box';
import { getAppTitle, getUserGroup } from '../helpers/groups';
import { observer } from 'mobx-react';

type HeaderProps = {
  title?: string;
  description?: string;
};

const Header: FC<HeaderProps> = observer(({ title, description }) => {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <header>
        <Box sx={{ mb: -2 }} key={getUserGroup() + '_1'}>
          <h1>{title ? title : getAppTitle()}</h1>
        </Box>
        {description ? <p>{description}</p> : null}
      </header>
    </Box>
  );
});

export default Header;
